// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2hnrk","left":"InfoRow_left__1to12"};